import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import GoogleOneTap from "./components/GoogleOneTap.jsx";
import { AppErrorBoundary } from "./AppErrorBoundary.jsx";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
      <GoogleOneTap />
    </AppErrorBoundary>
  </React.StrictMode>,
);
